import { Parser } from '@json2csv/plainjs';

import { downloadCSV } from '../../../tools/helpers';
import { type Column } from './index';

/**
 * Downloads rows as a CSV. Without `columns`, the headers are the first row's keys, in order.
 * Shared by the export button and by menus that can't keep a button mounted.
 */
export const downloadJsonAsCsv = (
  filename: string | (() => string),
  json: Array<unknown>,
  columns?: Column[],
) => {
  try {
    const fields =
      columns ||
      (typeof json[0] === 'object'
        ? Object.keys(json[0] as Record<string, unknown>).map((key) => ({
            label: key,
            value: key,
          }))
        : []);
    const parser = new Parser({ fields });
    const csv = parser.parse(json);
    downloadCSV(typeof filename === 'function' ? filename() : filename, csv);
  } catch (err) {
    console.log('parsing failed, file will not download', err);
  }
};
